import { PastaNetworkError } from "@pasta/box-v2";
import { retryCountOf } from "../http/network-retry.interceptor.ts";

type GetFingerprint = (error: Error) => string[];
type GetContext = (error: Error) => Record<string, Record<string, unknown>>;

export function withRouteNameFingerprint(fallback: GetFingerprint): GetFingerprint {
  return error => {
    const routeName =
      error instanceof PastaNetworkError ? error.axiosError.response?.headers?.["x-route-name"] : undefined;
    return routeName ? [String(routeName)] : fallback(error);
  };
}

export function withNetworkRetryContext(fallback: GetContext): GetContext {
  return error => {
    const context = fallback(error);
    if (!(error instanceof PastaNetworkError)) return context;

    const { config } = error.axiosError;
    const retries = retryCountOf(config);
    if (!retries) return context;

    return {
      ...context,
      networkRetry: { retries, online: navigator.onLine, method: config?.method?.toUpperCase(), path: config?.url },
    };
  };
}
